import { useGetMyProfileQuery } from "../employees/employeesSlice";

const useMyProfile = () => {
  const myProfile = useGetMyProfileQuery();
  return { ...myProfile, roles: myProfile?.data?.roles };
};

export default useMyProfile;
